import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Znamka} from '../model/znamka';
import { HttpClient } from '@angular/common/http';
import {HodnotenieDetail} from '../model/HodnotenieDetail';
import {AppService} from '../app.service';
import {HodnotenieSS} from '../model/HodnotenieSS';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-hodnotenie-detail',
    templateUrl: './hodnotenie-detail.component.html',
    styleUrls: ['./hodnotenie-detail.component.css'],
    standalone: false
})
export class HodnotenieDetailComponent implements OnInit {
  public title: string;
  public hodnotenie: HodnotenieDetail;
  public hodnotenieSS: HodnotenieSS;
  public isSS: boolean;

  constructor(
    public dialogRef: MatDialogRef<HodnotenieDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {znamka: Znamka},
    private http: HttpClient,
    private appService: AppService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {

    this.isSS = (this.data.znamka.kodCastSP === 'SS');

    let url = '/ais/rest/portal/student-predmety';

    if (this.isSS)
    {
      url += '/hodnotenie-detail-ss/' + this.data.znamka.id;

      this.http.get<HodnotenieSS>(url)
        .subscribe({
          next: (data) => {
            this.hodnotenieSS = data;
          },
          error: (error) => {
            this.appService.openErrorDialog(error.error.message);
          }
        });
    }
    else
    {
      url += '/hodnotenie-detail/' + this.data.znamka.id;

      this.http.get<HodnotenieDetail>(url)
        .subscribe({
          next: (data) => {
              this.hodnotenie = data;
            },
          error: (error) => {
              this.appService.openErrorDialog(error.error.message);
            }
        });
    }

  }

  getTitulok() {
    return this.translateService.instant('Hodnotenie predmetu');
  }

}
